const category = 'AppSpecificRegulatory';

const cards = [
    {
        name: "Dispute Status Maintenance",
        id: "disputeStatusMaintenance",
        fields: [
            [
                {
                    id: "ShouldAvoidCollectionOnDisputedAmount",
                },
            ],
            [
                {
                    id: "IsAutoPayEnrollmentStatusFromSOR",
                },
            ],
        ],
    },
    {
        name: "Regulatory Timing",
        id: "regulatoryTiming",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p class="subtitle-2">Is this client bound by RegE/RegZ?</p><p>RegE and RegZ provide protections to US consumers filing disputes.  By default, QFD clients are held to these regulations.  Non US clients may not be required to adhere to these regulations.</p>
            `,
                    configNoMargin: true,
                },
            ],
            [
                {
                    id: "IsClientBoundByRegE_Z",
                    configHideLabel: true,
                },
            ],
            [
                {
                    id: "RegEAreHolidaysWeekendsDay0",
                },
            ],
            [
                {
                    id: "RegDateAdjustmentsGuidance",
                },
            ],
            [
                {
                    id: "RegE10DateAdjust",
                    layout: [
                        [
                            {
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Start protection actions",
                                    },
                                    {
                                        type: "config",
                                        id: "DaysBeforeDefault",
                                    },
                                    {
                                        type: "content",
                                        content: "business days before at",
                                    },
                                    {
                                        type: "config",
                                        id: "TriggerTime",
                                    },
                                    {
                                        type: "content",
                                        content: "Default: 10/20 business days",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
            [
                {
                    id: "RegE45DateAdjust",
                    layout: [
                        [
                            {
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Start protection actions",
                                    },
                                    {
                                        type: "config",
                                        id: "DaysBeforeDefault",
                                    },
                                    {
                                        type: "content",
                                        content: "business days before at",
                                    },
                                    {
                                        type: "config",
                                        id: "TriggerTime",
                                    },
                                    {
                                        type: "content",
                                        content: "Default: 45 days",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
            [
                {
                    id: "RegE90DateAdjust",
                    layout: [
                        [
                            {
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Start protection actions",
                                    },
                                    {
                                        type: "config",
                                        id: "DaysBeforeDefault",
                                    },
                                    {
                                        type: "content",
                                        content: "business days before at",
                                    },
                                    {
                                        type: "config",
                                        id: "TriggerTime",
                                    },
                                    {
                                        type: "content",
                                        content: "Default: 90 days",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
            [
                {
                    id: "RegZ30DateAdjust",
                    layout: [
                        [
                            {
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Start protection actions",
                                    },
                                    {
                                        type: "config",
                                        id: "DaysBeforeDefault",
                                    },
                                    {
                                        type: "content",
                                        content: "business days before at",
                                    },
                                    {
                                        type: "config",
                                        id: "TriggerTime",
                                    },
                                    {
                                        type: "content",
                                        content: "Default: 30 days",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],
            [
                {
                    id: "RegZ90DateAdjust",
                    layout: [
                        [
                            {
                                type: "contentGroup",
                                items: [
                                    {
                                        type: "content",
                                        content: "Start protection actions",
                                    },
                                    {
                                        type: "config",
                                        id: "DaysBeforeDefault",
                                    },
                                    {
                                        type: "content",
                                        content: "business days before at",
                                    },
                                    {
                                        type: "config",
                                        id: "TriggerTime",
                                    },
                                    {
                                        type: "content",
                                        content: "Default: 2 statement cycles",
                                    },
                                ],
                            },
                        ],
                    ],
                },
            ],

        ],
    },
    {
        name: "Consumer Disputes Reg Configuration",
        id: "consumerDisputesReg",
        fields: [
            [
                {
                    id: "BOConsumerDisputeRegConfigGuidance",
                },
            ],
            [
                {
                    id: "BOHasConsumerDisputeRegProtectionForCredit",
                },
            ],
            [
                {
                    id: "BOHasConsumerDisputeRegProtectionForDebit",
                },
            ],
            [
                {
                    id: "AllowBackDatingCustomerContactDate",
                },
            ],
        ],
    },
    {
        name: "Statement Cycle Date Adjustments",
        id: "statementCycleDateAdjustments",
        fields: [
            [
                {
                    type: "content",
                    content: `
              <p>Statement Cycle Date is required in order to calculate the Regulation Z Resolution Date, which is 2 full statement cycles from the Customer Contact Date.  If Statement Cycle Date cannot be provided in the Account service, this setting can be used to set the date based on the BIN of the card that the claim is being filed against.  For each BIN specified, you must define the day of the month that the billing cycle ends and the statement is generated.  Only values of 1-28 are supported.</p>
            `,
                    configNoMargin: true,
                },
            ],
            [
                {
                    id: "StatementInfoList",
                    listItems: ["BIN", "CycleDay"],
                },
            ],
        ],
    },
];

export { cards, category };